import type { Story } from "@repo/fika-shared/src/loader/story-schema.js"
import { useParams } from "@solidjs/router"
import { getTitle } from "@/lib/getTitle"
import { createMatrixParams } from "@/lib/matrixParams"
import { generateUrl } from "@/lib/slug"

const PUBLISHERS_BASE_PATH = "/feeds" as const

export const FILTER = {
  discoveries: { value: "discoveries", iconName: "telescope", hue: "emerald" },
  subscriptions: {
    value: "subscriptions",
    iconName: "plus-circle",
    hue: "indigo",
  },
  ignored: { value: "ignored", iconName: "bell-off", hue: "rose" },
  all: { value: "all", iconName: "filter", hue: "sand" },
} as const
export type Filter = keyof typeof FILTER

interface ListParams {
  filter: Filter
  query: string
  tag: string
  page: number
}

const LIST_DEFAULTS: ListParams = {
  filter: "all",
  tag: "all",
  query: "",
  page: 1,
}

export function createPublishersRouter() {
  const params = useParams()
  const list = createMatrixParams(() => params.listParams, LIST_DEFAULTS)

  function paths(listParams?: Partial<ListParams>) {
    const url = `${PUBLISHERS_BASE_PATH}${list.makeURL(listParams)}`

    return {
      url,
      subscribe: () => `${url}/subscribe`,
      publisher: (publisher?: { id: string; dc_title: string | null }) => {
        const id = publisher
          ? generateUrl(getTitle(publisher.dc_title), publisher.id)
          : params.publisherId
        const publisherUrl = [url, "feed", id].filter(Boolean).join("/")

        return {
          url: publisherUrl,
          story: (story?: Story) => {
            const id = story
              ? generateUrl(getTitle(story.dc_title), story.id)
              : params.storyId
            const storyUrl = [publisherUrl, id].filter(Boolean).join("/")

            return { url: storyUrl }
          },
        }
      },
    }
  }

  return {
    paths,
    listParams: list.matrixParams,
  }
}
